import { connect } from 'react-redux';
import { MapDispatch, RootState } from '../../../store';
import { selectMessages } from '../../state/notificationsReducer';

const mapStateToProps = (state: RootState) => ({
  messages: selectMessages(state),
});

const mapDispatchToProps = {};

type Props = React.InputHTMLAttributes<any> &
  ReturnType<typeof mapStateToProps> &
  MapDispatch<typeof mapDispatchToProps>;

const MessageSelection = ({ value, onChange, messages }: Props) => {
  messages = messages.sort((a, b) => a.title.localeCompare(b.title));
  return (
    <select value={value} onChange={onChange}>
      <option disabled value="">
        -- Wähle eine Nachricht --
      </option>
      {messages.map((v) => (
        <option key={v.id} value={v.id}>
          {v.title}
        </option>
      ))}
    </select>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageSelection);
